/* FÉNIX 2.1 — R07 v70 · footer copy + single theme authority */
(function(){
  'use strict';

  function initFooterV31(){
    var footer=document.querySelector('footer.site-footer');
    if(!footer)return;
    footer.classList.add('nm-footer-v31');
    var news=footer.querySelector('.nm-footer-newsletter');
    if(!news)return;
    var kicker=news.querySelector('.nm-footer-kicker');
    if(kicker)kicker.textContent='NOVEDADES · OFERTAS';
    var title=news.querySelector('h4');
    if(title)title.textContent='Novedades y ofertas';
    var directParagraph=null;
    for(var i=0;i<news.children.length;i++){
      if(news.children[i].tagName==='P'){
        directParagraph=news.children[i];
        break;
      }
    }
    if(directParagraph){
      directParagraph.textContent='Recibe novedades, lanzamientos, guías y ofertas seleccionadas directamente en tu correo.';
    }
    var buttonText=news.querySelector('.nm-newsletter-form__submit span');
    if(buttonText)buttonText.textContent='Suscribirme';
  }

  function initThemeAuthorityV70(){
    if(window.__NM_THEME_AUTHORITY_V70__)return;
    window.__NM_THEME_AUTHORITY_V70__=true;

    var root=document.documentElement;
    var storageKey='nmTheme';

    function normalize(value){
      return value==='light'?'light':'dark';
    }

    function readSaved(){
      try{return localStorage.getItem(storageKey);}catch(e){return null;}
    }

    function currentTheme(){
      return normalize(root.getAttribute('data-nm-theme')||root.getAttribute('data-theme')||readSaved());
    }

    function syncControls(theme){
      var next=theme==='light'?'oscuro':'claro';
      var controls=document.querySelectorAll('.nm-theme-toggle');
      for(var i=0;i<controls.length;i++){
        controls[i].setAttribute('title','Cambiar a '+next);
        controls[i].setAttribute('aria-label','Cambiar a '+next);
        controls[i].setAttribute('aria-pressed',theme==='light'?'true':'false');
        controls[i].setAttribute('data-nm-theme-current',theme);
      }
    }

    function applyTheme(theme,persist){
      theme=normalize(theme);
      root.setAttribute('data-nm-theme',theme);
      root.setAttribute('data-theme',theme);
      root.setAttribute('data-nm-theme-authority','v70');
      root.classList.toggle('nm-theme-light',theme==='light');
      root.classList.toggle('nm-theme-dark',theme==='dark');
      root.style.colorScheme=theme;

      if(document.body){
        document.body.classList.toggle('nm-theme-light',theme==='light');
        document.body.classList.toggle('nm-theme-dark',theme==='dark');
      }

      if(persist){
        try{localStorage.setItem(storageKey,theme);}catch(e){}
      }

      syncControls(theme);

      try{
        window.dispatchEvent(new CustomEvent('nm:themechange',{detail:{theme:theme,authority:'v70'}}));
      }catch(e){}
    }

    function toggleTheme(){
      applyTheme(currentTheme()==='light'?'dark':'light',true);
    }

    document.addEventListener('click',function(event){
      var target=event.target;
      if(!target||!target.closest)return;
      var button=target.closest('.nm-theme-toggle');
      if(!button)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleTheme();
    },true);

    var initial=readSaved();
    if(initial!=='light'&&initial!=='dark')initial=currentTheme();
    applyTheme(initial,false);

    window.addEventListener('pageshow',function(){
      var saved=readSaved();
      applyTheme(saved==='light'||saved==='dark'?saved:currentTheme(),false);
    });

    if('MutationObserver' in window){
      var observer=new MutationObserver(function(mutations){
        var needsSync=false;
        for(var i=0;i<mutations.length&&!needsSync;i++){
          if(mutations[i].addedNodes&&mutations[i].addedNodes.length)needsSync=true;
        }
        if(needsSync)syncControls(currentTheme());
      });
      observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    window.NMTheme={
      get:currentTheme,
      set:function(theme){applyTheme(theme,true);},
      toggle:toggleTheme
    };
  }

  function init(){
    initFooterV31();
    initThemeAuthorityV70();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
